import Link from "@/components/ui/RouterLink";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";
import { categoryIcon } from "@/components/ui/icon-map";

export function ProductCategoryStrip() {
  return (
    <section id="products" className="border-y border-border bg-navy-secondary/50 py-3">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex gap-3 overflow-x-auto py-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:grid sm:grid-cols-5 sm:overflow-visible">
          {services.map((s) => {
            const Icon = categoryIcon[s.id];
            return (
              <Link
                key={s.id}
                href={s.href}
                className="focus-ring group flex min-w-[180px] flex-shrink-0 items-center gap-3 rounded-card border border-border bg-navy-card px-4 py-3.5 transition hover:border-cyan/40 sm:min-w-0"
              >
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-border bg-navy-secondary text-cyan">
                  <Icon className="h-4 w-4" strokeWidth={1.6} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-1 text-sm font-medium text-text-primary">
                    {s.name}
                    <ArrowUpRight className="h-3 w-3 opacity-0 transition group-hover:opacity-100" />
                  </span>
                  <span className="block truncate text-xs text-text-muted">{s.shortDescriptor}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
